import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserPoints, createPoint } from '../api/points';

/**
 * Shared "Play" action: navigates to the user's most recently active game,
 * or creates a first pixel and launches it.
 */
export const usePlayAction = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const play = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getUserPoints();
      const pts = res.data;
      if (pts.length > 0) {
        const last = pts.reduce((a, b) =>
          new Date(b.updated_at) > new Date(a.updated_at) ? b : a,
        );
        navigate(`/game/${last.id}`);
      } else {
        const created = await createPoint('');
        navigate(`/game/${created.data.id}`);
      }
    } catch {
      setLoading(false);
    }
  }, [navigate]);

  return { play, loading };
};
